import axios from "axios";
import { useState } from "react";
import styled from "styled-components";
import SectionHead from "../ui/common/SectionHead";
// ponytail: 화면만 리디자인. 전송(검증·axios.post·안내 문구)은 기존 그대로 둔다
const HomeOmbudsman = () => {
    const [input, setInput] = useState({ receiver: "관세법인 에이원 CEO", sender: "", title: "", content: "" });
    return (<Section>
        <div className="inner">
            <div className="form">
                <SectionHead eyebrow="Ask CEO" title="CEO에게 한마디" />
                <form onSubmit={async (e) => {
                    e.preventDefault();
                    if (!input?.sender.match(/^[\w\-.]+@([\w-]+\.)+[\w-]{2,4}$/)) {
                        alert(`입력하신 이메일 주소를 확인해주세요.`);
                        return;
                    }
                    await axios.post("https://ssek84ekyc.execute-api.ap-northeast-2.amazonaws.com/nodemail", {
                        from: input?.sender,
                        subject: input?.title,
                        text: input?.content,
                    });
                    alert(`${input?.sender}님께서 남겨주신 "${input?.title}" 제목의 내용을 전달했습니다. 소중한 의견 감사드립니다.`)
                }}>
                    <span className="label">
                        받는이
                    </span>
                    {/* 받는이는 고정 표시 (전송 내용에 포함되지 않음). 글자 번역을 위해 input 대신 텍스트로 */}
                    <div id="receiverInput">{input?.receiver}</div>
                    <label htmlFor="senderInput">
                        보내는 분 E-mail
                    </label>
                    <input id="senderInput" type="text" placeholder="보내는 분의 E-mail 주소" value={input?.sender} onChange={(e) => {
                        setInput(prev => ({ ...prev, sender: e.target.value }));
                    }} />
                    <label htmlFor="titleInput">
                        제목
                    </label>
                    <input id="titleInput" type="text" placeholder="제목" value={input?.title} onChange={(e) => {
                        setInput(prev => ({ ...prev, title: e.target.value }));
                    }} />
                    <label htmlFor="contentInput">
                        내용
                    </label>
                    <input id="contentInput" type="text" placeholder="내용" value={input?.content} onChange={(e) => {
                        setInput(prev => ({ ...prev, content: e.target.value }));
                    }} />
                    <button type="submit">보내기</button>
                </form>
            </div>
            <div className="image">
                {/* 옛 원색 일러스트(ASK_CEO2.png) 대신 브랜드 팔레트로 그린 말풍선 그래픽 */}
                <svg viewBox="0 0 420 320" role="img" aria-label="ASK CEO">
                    <defs>
                        <linearGradient id="askceoNavy" x1="0" y1="0" x2="1" y2="1">
                            <stop offset="0" stopColor="#1E3172" />
                            <stop offset="1" stopColor="#0B163D" />
                        </linearGradient>
                    </defs>
                    <circle cx="336" cy="64" r="44" fill="#E7F1FA" />
                    <circle cx="58" cy="258" r="28" fill="#E7F1FA" />
                    <g>
                        <rect x="40" y="58" width="240" height="118" rx="22" fill="url(#askceoNavy)" />
                        <path d="M88 176 L88 206 L122 176 Z" fill="#0B163D" />
                        <circle cx="122" cy="117" r="9" fill="white" opacity="0.9" />
                        <circle cx="160" cy="117" r="9" fill="white" opacity="0.6" />
                        <circle cx="198" cy="117" r="9" fill="white" opacity="0.35" />
                    </g>
                    <g>
                        <rect x="196" y="190" width="184" height="86" rx="18" fill="white" stroke="#E3E8F0" />
                        <path d="M330 275 L330 300 L303 275 Z" fill="white" />
                        <rect x="222" y="214" width="120" height="10" rx="5" fill="#0165AC" opacity="0.85" />
                        <rect x="222" y="236" width="86" height="10" rx="5" fill="#9FCBF2" />
                    </g>
                    <g>
                        <path d="M316 42 L368 22 L352 72 L336 54 Z" fill="#0165AC" />
                        <path d="M336 54 L352 72 L334 66 Z" fill="#14245C" />
                        <path d="M244 72 C 272 62, 296 52, 316 42" stroke="#9FCBF2" strokeWidth="3" strokeDasharray="2 9" fill="none" strokeLinecap="round" />
                    </g>
                </svg>
            </div>
        </div>
    </Section>)
}
export default HomeOmbudsman;
const Section = styled.section`
background-color: white;
& > .inner {
    max-width: ${({ theme }) => theme.layout.content};
    margin: 0 auto;
    padding: clamp(3.5rem, 7vw, 6rem) clamp(1.25rem, 4vw, 2.5rem);
    box-sizing: border-box;
    display: grid;
    grid-template-columns: minmax(0, 1fr) minmax(0, 1fr);
    gap: 4rem;
    align-items: center;
    @media (max-width: 767px) {
        grid-template-columns: minmax(0, 1fr);
        & > .image {
            display: none;
        }
    }
}
& .image {
    display: flex;
    justify-content: center;
    padding: 2rem;
    border-radius: 1.5rem;
    background-color: ${({ theme }) => theme.colors.monotone.extralight};
    & > svg {
        width: 85%;
        max-width: 26rem;
        height: auto;
    }
}
form {
    display: grid;
    grid-template-columns: 7.5rem minmax(0, 1fr);
    align-items: center;
    gap: 0.75rem 1rem;
    @media (max-width: 575px) {
        grid-template-columns: minmax(0, 1fr);
        gap: 0.4rem;
        & > label:not(:first-child) {
            margin-top: 0.5rem;
        }
    }
    & #receiverInput {
        user-select: none;
        border-radius: 0.6rem;
        border: 1px solid ${({ theme }) => theme.colors.monotone.light};
        padding: 0.8rem 1rem;
        background-color: ${({ theme }) => theme.colors.monotone.extralight};
        color: ${({ theme }) => theme.colors.foreground.dimmed};
    }
}
label, .label {
    font-size: 0.9rem;
    font-weight: 600;
    color: ${({ theme }) => theme.colors.monotone.dark};
}
input[type=text] {
    font-size: 1rem;
    border-radius: 0.6rem;
    border: 1px solid ${({ theme }) => theme.colors.monotone.light};
    padding: 0.8rem 1rem;
    color: ${({ theme }) => theme.colors.foreground.normal};
    transition: border-color 0.15s, box-shadow 0.15s;
    &::placeholder {
        color: ${({ theme }) => theme.colors.monotone.medium};
    }
    &:focus {
        outline: none;
        border-color: ${({ theme }) => theme.colors.accent};
        box-shadow: 0 0 0 3px ${({ theme }) => theme.colors.accentSoft};
    }
}
button[type=submit] {
    grid-column: 1 / -1;
    justify-self: end;
    margin-top: 0.5rem;
    cursor: pointer;
    border: 0px;
    border-radius: 999px;
    background-color: ${({ theme }) => theme.colors.dark};
    color: white;
    font-size: 1rem;
    font-weight: 700;
    padding: 0.9rem 2.4rem;
    transition: background-color 0.2s;
    &:hover {
        background-color: ${({ theme }) => theme.colors.accent};
    }
    @media (max-width: 575px) {
        justify-self: stretch;
    }
}
`
